import type { User } from '@core/entities/User';

export interface UserResponse {
  id: string;
  name: string;
  email: string;
  email_verified_at: string | null;
  avatar_url: string | null;
  timezone: string;
  locale: string;
  two_factor_enabled: boolean;
  current_workspace_id: string | null;
  created_at: string;
}

export interface UserEnvelope {
  data: UserResponse;
}

export const toUser = (payload: UserResponse): User => ({
  id: payload.id,
  name: payload.name,
  email: payload.email,
  emailVerifiedAt: payload.email_verified_at,
  avatarUrl: payload.avatar_url,
  timezone: payload.timezone,
  locale: payload.locale,
  twoFactorEnabled: payload.two_factor_enabled,
  currentWorkspaceId: payload.current_workspace_id,
  createdAt: payload.created_at,
});
